// extracted by mini-css-extract-plugin
export default {"GateBody":"randomBetween_GateBody__CI1Mp","MinInput":"randomBetween_MinInput__hXB50","MaxInput":"randomBetween_MaxInput__p0Z9Y"};